export const CLIENT_ID = Object.freeze({
  PF_INC: '02PF07PC',
  BM_FLOORING: '20PF10BM',
  INCREDIBLE: '16PF08II',
  PF_VALIDATION: '09PF05VD',
  PF_LLC: '61PF62AP',
  CFI_INSTALLATION: '24PF08CF',
  WTU: '19PF06WT',
  PROGRESSIVE_FENCE: '31PF03PR',
  FPN: '20PF02FS',
  ISN: '16PF04IN',
  PFDEMO: '16PF11PF',
  ACS: '12PF11AC',
  HUNTER: '25PF02HU',
  INTERFACE: '23PF10IN',
});

export const FPN_TENANT_CONSTANTS = {
  customer_id: 2216097,
};

export const FPN_ROLES = ['577'];
